import { render, staticRenderFns } from "./TestForms.vue?vue&type=template&id=a70a3c0c&scoped=true&"
import script from "./TestForms.vue?vue&type=script&lang=js&"
export * from "./TestForms.vue?vue&type=script&lang=js&"
import style0 from "./TestForms.vue?vue&type=style&index=0&id=a70a3c0c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a70a3c0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a70a3c0c')) {
      api.createRecord('a70a3c0c', component.options)
    } else {
      api.reload('a70a3c0c', component.options)
    }
    module.hot.accept("./TestForms.vue?vue&type=template&id=a70a3c0c&scoped=true&", function () {
      api.rerender('a70a3c0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/test/TestForms.vue"
export default component.exports